function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1333.25 0c36.86 0 66.75 29.885 66.75 66.75v1466.5c0 36.86-29.89 66.75-66.75 66.75H266.667c-36.819 0-66.667-29.85-66.667-66.67V866.667C200 829.848 229.848 800 266.667 800H525V466.667C525 429.848 554.848 400 591.667 400H850V66.75C850 29.885 879.885 0 916.75 0h416.5z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#prefix__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1400 66.75v1466.5c0 36.86-29.89 66.75-66.75 66.75h-416.5c-36.865 0-66.75-29.89-66.75-66.75V66.75C850 29.885 879.885 0 916.75 0h416.5c36.87 0 66.75 29.885 66.75 66.75z",
  fill: "url(#prefix__paint0_linear_8592:56198)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#prefix__filter0_dd_8592:56198)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1075 466.667V1600H525V466.667C525 429.848 554.848 400 591.667 400h416.663c36.82 0 66.67 29.848 66.67 66.667z",
  fill: "url(#prefix__paint1_linear_8592:56198)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M200 866.667v666.663c0 36.82 29.848 66.67 66.667 66.67H750V866.667C750 829.848 720.152 800 683.333 800H266.667C229.848 800 200 829.848 200 866.667z",
  fill: "url(#prefix__paint2_linear_8592:56198)"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__paint0_linear_8592:56198",
  x1: 758.333,
  y1: 0,
  x2: 1447.82,
  y2: 1507.15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6AD10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C87E0E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__paint1_linear_8592:56198",
  x1: 524.955,
  y1: 400,
  x2: 1105.79,
  y2: 1561.67,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6D751"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6AD10"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__paint2_linear_8592:56198",
  x1: 199.955,
  y1: 800,
  x2: 519.784,
  y2: 1581.68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9E589"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F6D751"
})), /*#__PURE__*/React.createElement("filter", {
  id: "prefix__filter0_dd_8592:56198",
  x: 391.667,
  y: 300,
  width: 816.667,
  height: 1466.67,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.333
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.333
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_8592:56198"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 33.333
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 66.667
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_8592:56198",
  result: "effect2_dropShadow_8592:56198"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_8592:56198",
  result: "shape"
})));

var SvgPowerbiLogo = function SvgPowerbiLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 1600 1600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 0,
    width: 1200,
    height: 1600
  }, _ref2), _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPowerbiLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/powerbi-logo.5c0f128b.svg";
export { ForwardRef as ReactComponent };